module.exports = __webpack_public_path__ + "static/media/create-fail.965a703d.png";